import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 16,
    marginBottom: 24
  },
  paper: {
    padding: '32px 20px',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    columnGap: 20
  },
  formItem: {},
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '30px 0px'
  },
  cancelButton: {
    background: theme.palette.grey[200],
    color: theme.palette.primary.dark,
    marginRight: 10
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  }
}))

export default useStyles
